import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { Tag } from "antd";

export function ChildUsername({ subUserName }: { subUserName: string }) {
  return <span>{subUserName}</span>;
}

export function DingTalkChildUsername({
  userName,
  isLeader,
}: {
  userName: string;
  isLeader: boolean;
}) {
  const t = getTranslateNsT("childManager");
  return (
    <span style={{ position: "relative" }}>
      {userName}
      {isLeader ? (
        <Tag className={"dingtalk-posts"}>
          {t("dingtalk_subaccount_director")}
        </Tag>
      ) : (
        ""
      )}
    </span>
  );
}
